import React from 'react';
import './cust.css';
import Profile from '../images/profile.jpeg'
import spong from '../images/spongbob.jpeg'

const RatingPage = () => {
    const customers = [
        { id: 1, name: 'Annet Liruh', image:Profile, rating: 4, review: 'Great service!' },
        { id: 2, name: 'Dennis Kefogo', image: Profile, rating: 5, review: 'Excellent experience!' },
        { id: 3, name: 'Abel Morara', image: Profile, rating: 3, review: 'Good but could be better.' },
        { id: 4, name: 'Charles Ntabo', image: spong, rating: 5, review: 'Highly recommended!' },
    ];

    return (
        <div className="rating-page">
            <h1>Client Reviews</h1>
            {customers.map((customer) => (
                <div className="customer" key={customer.id}>
                    <img className="customer-image" src={customer.image} alt={customer.name} />
                    <div className="customer-details">
                        <h3 className="customer-name">{customer.name}</h3>
                        <p className="customer-review">{customer.review}</p>
                        <div className="rating-stars">
                            {[...Array(customer.rating)].map((_, index) => (
                                <span key={index} className="star">&#9733;</span>
                            ))}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default RatingPage;
